/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;
        this.sessionKey = `${this.id}-session-dismissed`;
        this.dismissMode = this.dataset.dismissMode || 'permanent'; // 'permanent' or 'session'

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (this.shouldShow() && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.open(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          }
        }
      }

      /**
       * Check if popup should be shown based on dismiss mode
       * @returns {boolean}
       */
      shouldShow() {
        if (this.dismissMode === 'always') {
          // Always show mode - never check for dismissal
          return true;
        } else if (this.dismissMode === 'permanent') {
          // Use cookie for permanent dismissal
          return !getCookie(this.cookie);
        } else if (this.dismissMode === 'session') {
          // Use sessionStorage for session-only dismissal
          return !sessionStorage.getItem(this.sessionKey);
        }
        
        return true;
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && this.shouldShow()) this.open();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        
        if (this.dismissMode === 'permanent') {
          // Save to cookie for permanent dismissal
          setCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10));
        } else if (this.dismissMode === 'session') {
          // Save to sessionStorage for session-only dismissal
          sessionStorage.setItem(this.sessionKey, 'true');
        }
        // If dismissMode is 'always', don't save anything - popup will show again on refresh
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
